export default __webpack_public_path__ + "i18n/translations/translation-it.19983436.json";